<template>
  <el-table-column label="Vevő adatok">
    <el-table-column
      prop="customer_name"
      sortable="custom"
      label="Vevő"
      show-overflow-tooltip
      min-width="150"
    >
      <template slot-scope="scope">
        {{ scope.row.customer_name }}
      </template>
    </el-table-column>
    <el-table-column
      prop="customer_postal_code"
      label="Irányítószám"
      show-overflow-tooltip
      min-width="150"
      sortable="custom"
    >
      <template slot-scope="scope">
        {{ scope.row.customer_postal_code }}
      </template>
    </el-table-column>
    <el-table-column
      prop="customer_city"
      label="Város"
      show-overflow-tooltip
      min-width="150"
      sortable="custom"
    >
      <template slot-scope="scope">
        {{ scope.row.customer_city }}
      </template>
    </el-table-column>
    <el-table-column
      prop="customer_address"
      label="Cím"
      show-overflow-tooltip
      min-width="250"
      sortable="custom"
    >
      <template slot-scope="scope">
        {{ scope.row.customer_address }}
      </template>
    </el-table-column>
  </el-table-column>
</template>
<script>
export default {
  propName: 'customer',
};
</script>
